import Dexie, { Table } from 'dexie';
import { Article, ArticleCuttingParams, ArticleCuttingSpecsStd, ArticleCuttingSpecsTro, ArticleOverview, ArticleSpecs, TimestampDB } from '../../models/articleModel';
import { setDBLoadingState, setDBUpdatingState } from '../slices/db';
import store from '../store';
import { fillArticleCuttingParamStdDB, updateArticleCuttingParamStdDB } from './articleCuttingParamStdDB';
import { fillArticleCuttingParamTroDB, updateArticleCuttingParamTroDB } from './articleCuttingParamTroDB';
import { fillArticleOverviewDB, updateArticleOverviewTable } from './articleOverviewDB';
import { fillArticleDB, updateArticleDB } from './articleProductPriceAvailDB';
import { fillArticleSpecsDB, updateArticleSpecsTable } from './articleSpecs';
import { Material } from '../../models/materialModel';
import { fillMaterialTable, updateMaterialsTable } from './materialsDB';
import { fillArticleCuttingSpecsStdTable, updateArticleCuttingSpecsStdTable } from './articleCuttingSpecsStdDB';
import { fillArticleCuttingSpecsTroTable, updateArticleCuttingSpecsTroTable } from './articleCuttingSpecsTroDB';

export interface ArticleDB extends Article {
    id?: number;
}

export class LocalDatabase extends Dexie {
    // 'articles' is added by dexie when declaring the stores()
    // We just tell the typing system this is the case
    articles!: Table<ArticleDB>;
    articlesOverview!: Table<ArticleOverview>;
    articlesCuttingParamsStd!: Table<ArticleCuttingParams>;
    articlesCuttingParamsTro!: Table<ArticleCuttingParams>;
    articlesSpec!: Table<ArticleSpecs>;
    timestamps!: Table<TimestampDB>;
    materials!: Table<Material>;
    articleCuttingSpecsStd!: Table<ArticleCuttingSpecsStd>;
    articleCuttingSpecsTro!: Table<ArticleCuttingSpecsTro>;

    constructor() {
        super('localDatabase');
        // Versionsnummer muss mit jeder Änderung hochgezählt werden
        this.version(12).stores({
            timestamps: '&name, timestamp',
            articles: '++id, [ident+pos], preis, bestand', // Primary key and indexed props
            articlesOverview: 'id, ident, name, d1_max, d1_min, z_max, z_min, ttype, besch, trocut, serie',
            articlesCuttingParamsStd: 'id, [ident+pos], data',
            articlesCuttingParamsTro: 'id, [ident+pos], data',
            articlesSpec: 'id++, [ident+pos], d1, trocut, laenge, l2',
            materials: 'id, gruppe, nummer, din, frankreich, schweden, spanien, usa, japan, festigkeit_min, festigkeit_max, haerte_min, haerte_max',
            articleCuttingSpecsStd: 'id, ident, laengen',
            articleCuttingSpecsTro: 'id, ident, laengen'
        });
    }
}

export const db = new LocalDatabase();

db.open().then(() => {
}).catch(function (err) {
    console.error('Failed to open db: ' + (err.stack || err));
});

db.on('ready', async function () {
    fillInitial().then(() => {
        store.dispatch(setDBLoadingState(false));
    })
})

export const fillInitial = async () => {
    await Promise.all([
        fillArticleDB(),
        fillArticleOverviewDB(),
        fillArticleCuttingParamStdDB(),
        fillArticleCuttingParamTroDB(),
        fillArticleSpecsDB(),
        fillMaterialTable(),
        fillArticleCuttingSpecsStdTable(),
        fillArticleCuttingSpecsTroTable(),
    ])
}

export const mapTableUpdateFunctions = (val: string) => {
    switch (val) {
        case "articles": return updateArticleDB();
        case "articlesOverview": return updateArticleOverviewTable();
        case "articlesCuttingParamsStd": return updateArticleCuttingParamStdDB();
        case "articlesCuttingParamsTro": return updateArticleCuttingParamTroDB();
        case "articlesSpec": return updateArticleSpecsTable();
        case "materials": return updateMaterialsTable();
        case "articleCuttingSpecsStd": return updateArticleCuttingSpecsStdTable();
        case "articleCuttingSpecsTro": return updateArticleCuttingSpecsTroTable();
    }
}

export const updateTables = async (updateList: any) => {
    //console.log(updateList)
    await Promise.all(updateList)
        .then(() => {
            store.dispatch(setDBUpdatingState(false));
        })
}

